// extracted by mini-css-extract-plugin
export default {"box__select":"customSelect_box__select__LGGcS","box__option":"customSelect_box__option__17IMc"};